import helpers from './helpers';
import jsPDF from 'jspdf';
import moment from 'moment';
import { drawCabeceraEmpresa, drawFooterEmpresa } from './empresa_pdf';


/* Agregar imagen: addImage ( source, tipo, posicionX, posicionY, ancho, alto) */
/* addImage ( 'img.png', 'PNG', 100, 100, 50, 50) */
/* Agregar texto: text(texto, posicionX, posicionY) (se puede usar setFont, setFontSize, setTextColor, setFontType) */
/* pdf.setFontSize(20); pdf.setFont("times"); pdf.setFontType("bold"); pdf.setTextColor(255, 0, 0); */
/* A4: 210mm x 297 mm */


export default {
  methods: {
    exportPDFOrdenProveedor (ordenProveedor, empresa, asBlob) {
        let pdfName = 'orden_proveedor_'; 
        pdfName = pdfName.concat(ordenProveedor.id.toString().trim()); 
        /* Parametros: portrait, milimetros, A4 */
        var doc = new jsPDF('p', 'mm', 'a4');
        /* Cantidad de paginas */
        let pages = 1;

        doc.setProperties({
          title: 'OrdenProveedor',
          subject: 'OrdenProveedor',		
          author: 'Cervertti - Marketing & Eventos',
          creator: 'Cervetti'
        });

        let fontName = 'Montserrat-Regular';
        let fontBoldName = 'Montserrat-Bold';
        let fontItalicName = 'Montserrat-Italic';
        let fontBoldItalicName = 'Montserrat-BoldItalic';

        /* Interlineado */
        let interlineado = 3;
        let interlineadoOrdenes = 8;
        let interlineadoObservaciones = 3.5;
        /* Posicion inicial renglones */
        let positionRenglonesY = 95;
        /* Posicion inicial footer */
        let positionTerminosCondicionesY = 230;
        /* Limite para el salto de página */
        let positionMaxY = 250;

        /* Formato para alinear numeros a la derecha */
        let alignRight = {
          'align': 'right'
        }

        let cadena = '';

        /* Recuperamos el nro de orden de trabajo asociado */
        if (ordenProveedor.renglones) {
          if (ordenProveedor.renglones.length) {
            let renglon = ordenProveedor.renglones[0];
            if (renglon) {
              ordenProveedor.ordenTrabajoId = renglon.ordenTrabajoId;
            }
          }
        }

        let positionY = drawCabecera(doc, empresa, ordenProveedor, 
          fontName, fontBoldName, fontItalicName, fontBoldItalicName);
        positionY += 5;
        //let positionY = positionRenglonesY;

        /* Formas de pago */
        if (ordenProveedor.formasPago) {
          if (ordenProveedor.formasPago.length) {
            doc.setTextColor(60, 60, 60);
            doc.setFont(fontName, 'normal');
            // doc.setFontType('normal');
            doc.text('Condiciones de Pago', 10, positionY);
            positionY += 1;
            
            doc.setFontSize(8);
            doc.setTextColor(151, 148, 149);
            ordenProveedor.formasPago.forEach(formaPago => {
              positionY += interlineado;
              doc.text(`${formaPago.formaPago}`, 10, positionY);
              doc.text(`${this.$options.filters.numero(formaPago.porcentaje, true)} %`, 60, positionY);
              doc.text(`${formaPago.condiciones}`, 100, positionY);
            })

            positionY += interlineado;
            doc.setDrawColor(151, 148, 149); 
            doc.setLineWidth(0.3);
            doc.line(10, positionY, 200, positionY);
            positionY += 5;
          }
        }

        let ordenInterna = false;
        if (ordenProveedor.renglones) {
          if (ordenProveedor.renglones.length != 0) {
            let renglon = ordenProveedor.renglones[0];
            if (renglon) {
              if (renglon.ordenSubtrabajoId == 0) {
                ordenInterna = true;
              }
            }
          }
        }

        /* Renglones */
        doc.setTextColor(60, 60, 60);
        doc.setFont(fontName, 'normal');
        doc.setFontType('normal');

        if (ordenInterna) {
          doc.text('Descripción', 10, positionY);
        } else {
          doc.text('Número', 10, positionY);
          doc.text('Descripción', 25, positionY);
        }
        doc.text('Cantidad', 140, positionY, alignRight);
        if (!ordenProveedor.ordenSinCostos) {
          doc.text('Importe Total', 180, positionY, alignRight);
        }

        let inicial = true;

        if (ordenProveedor.renglones) {
          if (ordenProveedor.renglones.length) {
            ordenProveedor.renglones.forEach(renglon => {

              /* Verificamos si entra el titulo del renglón y al menos dos renglones de observaciones */
              if (positionY + interlineadoOrdenes + 5 > positionMaxY) {
                /* Mostamos el footer */
                drawFooterEmpresa(doc, empresa, fontName);

                /* Agregamos una pagina nueva */
                doc.addPage();
                pages++;
                positionY = drawCabecera(doc, empresa, ordenProveedor, 
                  fontName, fontBoldName, fontItalicName, fontBoldItalicName);
                positionY += 5;
                //positionY = positionRenglonesY;

              } else {
                if (inicial) {
                  /* Renglon inicial luego del titulo */
                  positionY += 4;
                  inicial = false;
                } else {
                  positionY += interlineadoOrdenes;
                }
              }

              doc.setTextColor(60, 60, 60);

              if (ordenInterna) {
                doc.text(`${renglon.articuloTipo}`, 10, positionY);
              } else {
                doc.text(`${renglon.ordenSubtrabajoId}`, 20, positionY, alignRight);
                doc.text(`${renglon.articuloTipo}`, 25, positionY);
              }
              doc.text(`${renglon.cantidad}`, 140, positionY, alignRight);
              if (!ordenProveedor.ordenSinCostos) {
                doc.text(`${this.$options.filters.moneda(renglon.montoTotal, ordenProveedor.moneda)}`, 180, positionY, alignRight);
              }

              positionY += interlineado;

              /* Observaciones */
              if (renglon.observaciones) {
                if (renglon.observaciones != '') {
                  let lineasObservaciones = renglon.observaciones.split(/\r?\n/g);

                  // console.log(lineasObservaciones);

                  doc.setTextColor(151, 148, 149);

                  for (let linea = 0; linea < lineasObservaciones.length; linea++) {
                    if (positionY + interlineadoObservaciones >= positionMaxY) {
                      /* Mostamos el footer */
                      drawFooterEmpresa(doc, empresa, fontName);

                      /* Agregamos una pagina nueva */
                      doc.addPage();
                      pages++;
                      positionY = drawCabecera(doc, empresa, ordenProveedor, 
                        fontName, fontBoldName, fontItalicName, fontBoldItalicName);
                      positionY += 5;
                      //positionY = positionRenglonesY;
                    
                      /* Titulos */
                      doc.setTextColor(60, 60, 60);
                      doc.setFont(fontName, 'normal');
                      // doc.setFontType('normal');
                      if (ordenInterna) {
                        doc.text('Descripción', 10, positionY);
                      } else {
                        doc.text('Número', 10, positionY);
                        doc.text('Descripción', 25, positionY);
                      }
                      doc.text('Cantidad', 140, positionY, alignRight);
                      if (!ordenProveedor.ordenSinCostos) {
                        doc.text('Importe Total', 180, positionY, alignRight);
                      }

                      positionY += interlineado + 2;

                      doc.setFontSize(7);
                      doc.setFont(fontItalicName, 'italic');
                      // doc.setFontType('italic');
          
                      doc.text('Continuación ...', 15, positionY);
          
                      doc.setFontSize(7);
                      doc.setFont(fontName, 'normal');
                      // doc.setFontType('normal');
                
                      positionY += interlineadoObservaciones + 2;
          
                    } else {
                      positionY += interlineadoObservaciones;
                    }

                    if (lineasObservaciones[linea].length > 135) {
                      let lastSpace = lineasObservaciones[linea].substring(0, 135).search(/ [^ ]*$/);
                      /* Dividimos la linea en dos */
                      doc.text(lineasObservaciones[linea].substring(0, lastSpace).trim(), 10, positionY);
                      positionY += interlineadoObservaciones;
                      doc.text(lineasObservaciones[linea].substring(lastSpace + 1).trim(), 10, positionY);
          
                    } else {
                      doc.text(lineasObservaciones[linea], 10, positionY);
                    }
                  }
                }                      
              }
            })
          }
        }

        let addPage = false;
        if (ordenProveedor.condicionFiscalId == 1) {
          if (positionY + 30 > positionTerminosCondicionesY) {
            addPage = true;
          }
        } else {
          if (positionY + 26 > positionTerminosCondicionesY) {
            addPage = true;
          }
        }
        if (addPage) {
          /* Mostamos el footer */
          drawFooterEmpresa(doc, empresa, fontName);
          
          /* Agregamos una pagina nueva */
          doc.addPage();
          pages++;
          positionY = drawCabecera(doc, empresa, ordenProveedor, 
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
          positionY += 5;
          // positionY = positionRenglonesY + 10;
        } else {
          positionY += 20;
        }

        /* Totales */
        if (!ordenProveedor.ordenSinCostos) {
          doc.setFontSize(8);
          doc.setFont(fontBoldName, 'bold');
          doc.setTextColor(60, 60, 60);

          if (ordenProveedor.condicionFiscalId == 1) {
            // doc.setTextColor(232, 67, 113);
            doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
            doc.text(`Total: ${this.$options.filters.moneda(ordenProveedor.montoTotal, ordenProveedor.moneda)}`, 180, positionY, alignRight);
            positionY += 5;
            doc.setFontSize(6);
            doc.setFont(fontItalicName, 'italic');
            doc.setTextColor(151, 148, 149);
            doc.text(`(IVA no incluido)`, 176, positionY, alignRight);
          } else {
            // doc.setTextColor(232, 67, 113);
            doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
            doc.text(`Total: ${this.$options.filters.moneda(ordenProveedor.montoTotal, ordenProveedor.moneda)}`, 180, positionY, alignRight);
            positionY += 5;
            doc.setFontSize(6);
            doc.setFont(fontItalicName, 'italic');
            doc.setTextColor(151, 148, 149);
            doc.text(`(Precio final IVA incluido no discriminado)`, 190, positionY, alignRight);
          }
        }
        
        /* Terminos y condiciones */
        drawTerminosCondiciones(doc, empresa, fontName, fontBoldName, fontItalicName, fontBoldItalicName, positionTerminosCondicionesY);
        
        /* Pie de pagina */
        drawFooterEmpresa(doc, empresa, fontName);

        /* Numeramos las páginas */
        for (let index = pages - 1; index >= 0; index--) {
          doc.setPage(index + 1);
          doc.setFont(fontName, 'normal');
          doc.setFontSize(6);
          doc.setTextColor(0, 0, 0);
          cadena = new String().concat('Página ', (index + 1).toString(), " de ", pages.toString());
          doc.text(cadena, 10, 286);
        }

        /* Opción para enviar PDF via email */
        if (asBlob) {
          return doc.output('blob');
        }

        window.open(doc.output("bloburl", { filename: pdfName + '.pdf' } ));

        return;
    },
  }
}

function drawCabecera(doc, empresa, ordenProveedor, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName) {

  /* Verificamos si tiene logo asociado */
  let logoAsociado = (empresa.logoWeConnect.trim() != '')? true : false;

  drawCabeceraEmpresa({
    doc, 
    empresa, 
    fontName,
    dark: true,
    fontSize: 7.5,
    logoAsociado
  });

  let alignRight = {
    'align': 'right'
  }

  /* Titulo */
  doc.setFont(fontName, 'normal');
  doc.setFontSize(28);
  // doc.setTextColor(232, 67, 113);
  doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
  doc.text('Orden a Proveedor', 60, 20);

  doc.setFontSize(10);
  doc.text('ATENCIÓN - DATOS PARA LA FACTURACIÓN', 68, 34);


  doc.setFontSize(10);
  // doc.setTextColor(232, 67, 113);
  doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);

  let positionY = 18;
  if ((/true/i).test(logoAsociado)) {
    positionY = 40;
  }

  let ordenProveedorNumero = "0000000" + ordenProveedor.id;
  ordenProveedorNumero = ordenProveedorNumero.substr(ordenProveedorNumero.length - 8);
  //doc.text(cadena, 160, positionY);
  doc.text(`Nº: 00001-${ordenProveedorNumero}`, 200, positionY, alignRight);

  doc.setTextColor(0, 0, 0);
  positionY += 5;
  doc.text(`Fecha: ${moment(ordenProveedor.fechaComprobante).format('DD/MM/YYYY')}`, 200, positionY, alignRight);

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);

  positionY = 56;
  if ((/true/i).test(logoAsociado)) {
    positionY = 65;
  }

  doc.line(10, positionY, 200, positionY);

  doc.setFontSize(8);

  /* Datos del destino */
  positionY += 5;
  doc.text(`Proveedor: ${ordenProveedor.proveedor.trim()}`, 10, positionY);
  doc.text(`Contacto: ${ordenProveedor.usuario.trim()}`, 120, positionY);
  positionY += 4;
  doc.text(`Anunciante: ${ordenProveedor.cliente.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Acción: ${ordenProveedor.accion.trim()}`, 10, positionY);
  doc.text(`Nro. PI: ${ordenProveedor.presupuestoNumero.trim()}`, 120, positionY);
  
  positionY += 6;
  if (moment(ordenProveedor.fechaEntrega).format('YYYY-MM-DD') != '1900-01-01') {
    doc.text(`Entrega Pactada: ${moment(ordenProveedor.fechaEntrega).format('DD/MM/YYYY')}`, 10, positionY);
  } else {
    doc.text(`Entrega Pactada:   /  /    `, 10, positionY);
  }
  positionY += 4;
  doc.text(`Dirección de Entrega: ${ordenProveedor.direccionEntrega}`, 10, positionY);

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);
  positionY += 4;
  doc.line(10, positionY, 200, positionY);

  /* Agregamos leyenda de anulado */
  if (moment(ordenProveedor.fechaBorrado).format('YYYY-MM-DD') != '1900-01-01') {
    doc.setFontSize(40);
    doc.setTextColor(151, 148, 149);
    doc.text(70, 160, 'A N U L A D O', null, 45);
    doc.setFontSize(8);
    doc.setTextColor(60, 60, 60);
  }

  return positionY;
}

function drawTerminosCondiciones(doc, empresa, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName, positionY) {
    doc.setFontSize(8);
    doc.setFont(fontName, 'normal');
    // doc.setFontType('normal');
    doc.setTextColor(151, 148, 149);
    doc.text(`Remitir facturas a ${empresa.emailProveedores.trim()}`, 10, positionY);

    positionY += 8;
    doc.setFontSize(12);
    // doc.setTextColor(232, 67, 113);
    doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
    doc.text('Términos y Condiciones', 10, positionY);

    positionY += 5;
    doc.setFontSize(6);
    // doc.setFont(fontName);
    // doc.setFontType('normal');
    doc.setTextColor(151, 148, 149);
    doc.text('El PROVEEDOR deberá mantener informado a la AGENCIA de los avances de los trabajos y comunicará en forma inmediata de toda dificultad, alteración u obstáculo', 10, positionY);
    positionY += 4;
    doc.text('que pueda presentarse. El trabajo encomendado al PROVEEDOR se tiene por cumplido cuando la AGENCIA ha verificado y dado conformidad expresa que se', 10, positionY);
    positionY += 4;
    doc.text('encuentra correctamente concluido siguiendo la forma, requerimientos, condiciones y plazos acordados. A partir de entonces el PROVEEDOR tiene derecho a percibir', 10, positionY);
    positionY += 4;
    doc.text('los pagos. La entrega de los trabajos encomendados luego de vencidos los plazos requeridos importa el incumplimiento total de la orden de trabajo aún cuando la', 10, positionY);
    positionY += 4;
    doc.text('demora hubiese sido por cuestiones no imputables directamente al PROVEEDOR. Hasta tanto el PROVEEDOR no informe y acredite la terminación del trabajo la', 10, positionY);
    positionY += 4;
    doc.text('AGENCIA podrá, sin necesidad de invocar causa, cancelar la presente orden de trabajo. En ningún caso la cancelación de la orden de trabajo dará al', 10, positionY);
    positionY += 4;
    doc.text('PROVEEDOR derecho a reclamo y/o resarcimiento de ninguna naturaleza.', 10, positionY);
    positionY += 4;
    doc.setFont(fontBoldName, 'bold');
    // doc.setFontType('normal');
    doc.text('Es OBLIGATORIO el envío de fotos/muestras para aprobar el inicio de la producción.', 10, positionY);
    positionY += 4;
    doc.text('Es OBLIGATORIO el envío de fotos/muestras final para aprobar la producción final y proceder al proceso de pago.', 10, positionY);
}

